import * as React from 'react'

import ButtonGroup from '@mui/material/ButtonGroup'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import ClickAwayListener from '@mui/material/ClickAwayListener'
import Grow from '@mui/material/Grow'
import Paper from '@mui/material/Paper'
import Popper from '@mui/material/Popper'
import MenuItem from '@mui/material/MenuItem'
import MenuList from '@mui/material/MenuList'
import { Download, Upload } from '@mui/icons-material'
import { Typography } from '@mui/material'
import Button from '../CustomButton'

type Props = {
  open: boolean
  setOpen: any
  selectedIndex: number
  setSelectedIndex: any
  handleClick: any
  propOptions?: any
  loader?: boolean
}

export default function SplitButton(props: Props) {
  const { open, setOpen, selectedIndex, setSelectedIndex, handleClick, propOptions, loader } = props
  const anchorRef = React.useRef<HTMLDivElement>(null)

  const options = propOptions || [
    <Typography>
      <Download className="mr-2" fontSize="small" /> Import Data
    </Typography>,
    <Typography>
      <Upload className="mr-2" fontSize="small" /> Download Template
    </Typography>,
  ]

  const handleMenuItemClick = (event: React.MouseEvent<HTMLLIElement, MouseEvent>, index: number) => {
    setSelectedIndex(index)
    handleClick()
    setOpen(false)
  }

  const handleToggle = () => {
    setOpen((prevOpen: boolean) => !prevOpen)
  }

  const handleClose = (event: Event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target as HTMLElement)) {
      return
    }

    setOpen(false)
  }

  return (
    <React.Fragment>
      <ButtonGroup disabled={loader} variant="outlined" ref={anchorRef} aria-label="Button group with a nested menu" className="mr-2">
        <Button 
          variant="outlined" 
          className={`!normal-case ${loader ? '!opacity-75' : ''}`} 
          onClick={handleClick} 
          disabled={loader}
        >
          {loader ? (
            <span className="flex items-center">
              <span className="mr-2 h-4 w-4 animate-spin rounded-full border-2 border-current border-t-transparent"></span>
              {options[selectedIndex]}
            </span>
          ) : (
            options[selectedIndex]
          )}
        </Button>
        <Button
          variant="outlined"
          aria-controls={open ? 'split-button-menu' : undefined}
          aria-expanded={open ? 'true' : undefined}
          aria-label="select merge strategy"
          aria-haspopup="menu"
          onClick={handleToggle}
          disabled={loader}
        >
          <ArrowDropDownIcon />
        </Button>
      </ButtonGroup>
      <Popper sx={{ zIndex: 1024, background: 'white' }} className="border" open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal>
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList id="split-button-menu" autoFocusItem>
                  {options.map((option: any, index: number) => (
                    <MenuItem
                      // className={selectedIndex === index ? '!hidden' : ''}
                      key={index}
                      selected={index === selectedIndex}
                      onClick={(event) => {
                        handleMenuItemClick(event, index)
                      }}
                    >
                      {option}
                    </MenuItem>
                  ))}
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>
    </React.Fragment>
  )
}
